/**
 * @param dataWrapper {ReturnType<import('core/data/data-wrapper')._DB>}
 */
export function createRiderRepository(dataWrapper) {
  const DOCUMENT_KEY = 'rider'
  const { list, get } = dataWrapper

  const _listRiders = (list) => list(DOCUMENT_KEY)

  const listRiders = () => _listRiders(list)

  const _getRider = (get, code) => get(`${DOCUMENT_KEY}_${code}`)

  const getRider = (code) => _getRider(get, code)

  return {
    _listRiders,
    listRiders,
    _getRider,
    getRider,
  }
}
